/* Globber CL — ficha de producto: entrega estimada, promo con fechas, barra fija, pestañas, descripción y galería. */
(() => {
  if (window.__gbPdp) return;
  window.__gbPdp = true;

  const TZ = 'America/Santiago';

  // Fecha y hora actuales en Chile, sin depender de la zona del dispositivo.
  function nowInChile() {
    const parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23',
    }).formatToParts(new Date());
    const p = Object.fromEntries(parts.map((x) => [x.type, x.value]));
    return { date: new Date(Date.UTC(+p.year, +p.month - 1, +p.day)), hour: +p.hour };
  }

  const isoDay = (d) => d.toISOString().slice(0, 10);
  const isBusinessDay = (d, holidays) => d.getUTCDay() !== 0 && d.getUTCDay() !== 6 && !holidays.has(isoDay(d));

  function addBusinessDays(from, n, holidays) {
    const d = new Date(from);
    let added = 0;
    while (added < n) {
      d.setUTCDate(d.getUTCDate() + 1);
      if (isBusinessDay(d, holidays)) added++;
    }
    return d;
  }

  const dayFmt = new Intl.DateTimeFormat('es-CL', { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' });
  function shortDate(d) {
    const p = Object.fromEntries(dayFmt.formatToParts(d).map((x) => [x.type, x.value]));
    return `${p.weekday} ${p.day} ${p.month}`.replace(/\./g, '');
  }

  function initEta(el) {
    const holidays = new Set((el.dataset.holidays || '').split(/[\s,]+/).filter(Boolean));
    const { date, hour } = nowInChile();
    // Día en que se procesa el pedido: hoy si es hábil y antes del corte; si no, el siguiente hábil.
    let start = date;
    if (!isBusinessDay(start, holidays) || hour >= Number(el.dataset.cutoff || 14)) {
      start = addBusinessDays(start, 1, holidays);
    }
    const from = addBusinessDays(start, Number(el.dataset.min || 1), holidays);
    const to = addBusinessDays(start, Number(el.dataset.max || 3), holidays);
    const label = el.dataset.label || 'Llega entre el';
    el.innerHTML = isoDay(from) === isoDay(to)
      ? `${label.replace(/ entre el$/, ' el')} <b>${shortDate(from)}</b>`
      : `${label} <b>${shortDate(from)}</b> y el <b>${shortDate(to)}</b>`;
  }

  function initPromo(el) {
    const start = Date.parse(el.dataset.start);
    const end = Date.parse(el.dataset.end);
    const now = Date.now();
    if (!Number.isNaN(start) && !Number.isNaN(end) && now >= start && now <= end) el.hidden = false;
  }

  function initSticky(bar) {
    const form = document.querySelector('.product-information product-form-component');
    const mainBtn = form && form.querySelector('button[name="add"]');
    if (!mainBtn) return;

    // Se mueve al body para que ningún contenedor del tema altere el position: fixed.
    document.body.appendChild(bar);
    const btn = bar.querySelector('[data-gb-sticky-add]');
    let formPassed = false;
    let footerVisible = false;
    let addedTimer;

    const syncState = () => {
      if (addedTimer) return;
      btn.disabled = mainBtn.disabled;
      btn.textContent = mainBtn.disabled ? bar.dataset.soldout : bar.dataset.add;
    };

    const update = () => {
      const show = formPassed && !footerVisible;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', String(!show));
      btn.tabIndex = show ? 0 : -1;
      document.body.classList.toggle('gb-sticky-on', show);
      if (show) syncState();
    };

    btn.addEventListener('click', () => {
      if (mainBtn.disabled) return;
      mainBtn.click();
    });

    document.addEventListener('cart:update', () => {
      if (!bar.classList.contains('is-visible')) return;
      btn.textContent = bar.dataset.added;
      clearTimeout(addedTimer);
      addedTimer = setTimeout(() => { addedTimer = null; syncState(); }, 2000);
    });

    new IntersectionObserver(([entry]) => {
      formPassed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      update();
    }).observe(form);

    const footer = document.querySelector('.shopify-section-group-footer-group');
    if (footer) {
      new IntersectionObserver(([entry]) => {
        footerVisible = entry.isIntersecting;
        update();
      }).observe(footer);
    }
  }


  // Pestañas (escritorio) y acordeones (celular) sobre los mismos paneles.
  function initTabs(root) {
    const tabs = [...root.querySelectorAll('[data-gb-tab]')];
    const panels = [...root.querySelectorAll('[data-gb-panel]')];
    const select = (name) => {
      tabs.forEach((t) => {
        const on = t.dataset.gbTab === name;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
      });
      panels.forEach((p) => p.classList.toggle('is-active', p.dataset.gbPanel === name));
    };
    tabs.forEach((t, i) => {
      t.addEventListener('click', () => select(t.dataset.gbTab));
      t.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        const next = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
        next.focus();
        select(next.dataset.gbTab);
      });
    });
    root.querySelectorAll('[data-gb-acc]').forEach((b) => {
      b.addEventListener('click', () => {
        const open = b.closest('[data-gb-panel]').classList.toggle('is-open');
        b.setAttribute('aria-expanded', String(open));
      });
    });
  }

  // Descripción: limpia restos vacíos, marca los párrafos en negrita como títulos y recorta con "Leer más".
  function initStory(el) {
    const h1 = document.querySelector('.product-information h1');
    const title = h1 ? h1.textContent.trim().toLowerCase() : '';
    el.querySelectorAll('p, div').forEach((node) => {
      const text = node.textContent.replace(/\s+/g, ' ').trim();
      if (!text && !node.querySelector('img, iframe, video')) { node.remove(); return; }
      const b = node.querySelector(':scope > b, :scope > strong');
      if (b && text === b.textContent.replace(/\s+/g, ' ').trim() && text.length < 90) {
        if (text.toLowerCase() === title) { node.remove(); return; }
        node.classList.add('gb-h');
      }
    });
    const more = el.parentElement.querySelector('[data-gb-more]');
    if (!more) return;
    const limit = window.matchMedia('(min-width: 990px)').matches ? 380 : 300;
    if (el.scrollHeight <= limit + 80) return;
    el.style.setProperty('--gb-clamp', `${limit}px`);
    el.classList.add('is-clamped');
    const label = more.textContent;
    more.hidden = false;
    more.setAttribute('aria-expanded', 'false');
    more.addEventListener('click', () => {
      const expanded = el.classList.toggle('is-expanded');
      more.textContent = expanded ? 'Ver menos' : label;
      more.setAttribute('aria-expanded', String(expanded));
      if (!expanded) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  // Galería: contador "1 / 15" y "+N" sobre la séptima miniatura.
  function initGallery() {
    const g = document.querySelector('.product-information media-gallery');
    if (!g) return;
    const slides = [...g.querySelectorAll('slideshow-slide')];
    if (slides.length < 2) return;
    const host = g.querySelector('slideshow-container') || g;
    const count = document.createElement('span');
    count.className = 'gb-media-count';
    count.setAttribute('aria-hidden', 'true');
    const update = () => {
      const i = slides.findIndex((s) => s.getAttribute('aria-hidden') === 'false');
      count.textContent = `${i < 0 ? 1 : i + 1} / ${slides.length}`;
    };
    update();
    host.appendChild(count);
    const mo = new MutationObserver(update);
    slides.forEach((s) => mo.observe(s, { attributes: true, attributeFilter: ['aria-hidden'] }));
    const thumbs = [...g.querySelectorAll('.slideshow-controls__thumbnail')];
    if (thumbs.length > 7) {
      thumbs[6].classList.add('gb-thumb-more');
      thumbs[6].dataset.more = `+${thumbs.length - 7}`;
    }
  }

  function init() {
    document.querySelectorAll('[data-gb-eta]').forEach(initEta);
    document.querySelectorAll('[data-gb-promo]').forEach(initPromo);
    document.querySelectorAll('[data-gb-tabs]').forEach(initTabs);
    document.querySelectorAll('[data-gb-story]').forEach(initStory);
    initGallery();
    const bar = document.querySelector('[data-gb-sticky]');
    if (bar) initSticky(bar);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
